import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { downloadCSV, downloadExcel, downloadTableAsPDF } from "@/lib/utils";
import Csv from "@/components/svg/Csv";
import Excel from "@/components/svg/Excel";
import PDF from "@/components/svg/PDF";
import { Download } from "lucide-react";

type DownloadDataDropdownProps<T> = {
  data: T[];
  title?: string;
  id?: string | null;
};

function DownloadDataDropdown<T>({
  data,
  title,
  id
}: DownloadDataDropdownProps<T>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        id={id || "download-data-fe-drp-dwn-menu"}
        asChild
      >
        <div className="rounded-full m-2 text-white download-data-button flex justify-center items-center w-[40px] h-[40px]">
          <Download />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent id="download-data-fe-drp-dwn-content">
        <DropdownMenuItem
          id="download-data-fe-drp-dwn-item-pdf"
          className="flex items-center text-gray-500 font-semibold gap-5 justify-center"
          onClick={() => downloadTableAsPDF(title || "", data as object[])}
        >
          <PDF />
          PDF
        </DropdownMenuItem>

        <DropdownMenuItem
          id="download-data-fe-drp-dwn-item-excel"
          className="flex items-center text-gray-500 font-semibold gap-5 justify-center"
          onClick={() => downloadExcel(title || "Excel format", data)}
        >
          <Excel /> Excel
        </DropdownMenuItem>

        <DropdownMenuItem
          id="download-data-fe-drp-dwn-item-csv"
          className="flex items-center text-gray-500 font-semibold gap-5 justify-center"
          onClick={() => downloadCSV(data as object[], title || "")}
        >
          <Csv />
          CSV
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default DownloadDataDropdown;
